var _ellipse, _path, _path2, _rect, _circle, _circle2, _path3, _path4, _rect2, _rect3, _g, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAccessLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 218,
    viewBox: "0 0 116 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 57.5,
    rx: 58,
    ry: 57.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7358 68H76.2642L104 217H10L37.7358 68Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8621 174H59V217.345H91V187.138L77.8621 174Z",
    fill: "#00CA72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.5312,
    y: 80,
    width: 25,
    height: 25,
    rx: 1,
    transform: "rotate(51.3717 49.5312 80)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 199.5,
    r: 17.5,
    fill: "#FFCC00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 82,
    r: 12,
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4545 157.454C84.7714 140.458 79.357 118.317 62.361 108L25 169.548C41.996 179.865 64.1375 174.45 74.4545 157.454Z",
    fill: "#6161FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8477 48.6801L54.611 74.2721L47.1053 76.8802L42.7617 71.2393L32.629 74.7604L32.6776 81.8937L25.1718 84.5019L25.6331 51.5346L33.8477 48.6801ZM32.551 68.6186L38.9726 66.3872L32.4437 57.9539L32.551 68.6186Z",
    fill: "#6161FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1074,
    y: 23,
    width: 45.8238,
    height: 34.2566,
    transform: "rotate(10.2711 53.1074 23)",
    fill: "#00CA72"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_492_18943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 23,
    width: 52,
    height: 42
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1094,
    y: 23.001,
    width: 45.9992,
    height: 33.9454,
    rx: 0.817769,
    transform: "rotate(10.2711 53.1094 23.001)",
    fill: "#CFCFF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_492_18943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3044 38.6798C65.0386 37.0656 67.8376 37.5728 68.8952 39.6929L83.3695 68.7101C84.6731 71.3235 82.4366 74.3044 79.5629 73.7837L41.3526 66.8596C38.4789 66.3388 37.4306 62.7627 39.5684 60.7729L63.3044 38.6798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2809 46.528C81.0152 44.9137 83.8142 45.4209 84.8717 47.5411L99.346 76.5583C100.65 79.1716 98.4131 82.1526 95.5395 81.6318L57.3292 74.7077C54.4555 74.187 53.4072 70.6108 55.5449 68.621L79.2809 46.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5195 50.9633L83.3722 68.7107C84.6758 71.3241 82.4393 74.305 79.5656 73.7843L54.9593 69.3253C55.1187 69.0758 55.3144 68.8391 55.5483 68.6215L74.5195 50.9633Z",
    fill: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.151,
    cy: 36.9033,
    r: 3.3923,
    transform: "rotate(10.2711 78.151 36.9033)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccessLogo);
export default __webpack_public_path__ + "static/media/no-access-logo.86772e665049949edc355444840c2792.svg";
export { ForwardRef as ReactComponent };